/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classNames from 'classnames';
import striptags from 'striptags';
import isString from 'lodash/isString';
import he from 'he';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import MoreInfo from '../partials/MoreInfo';

import styles from '../../../styles/cards/production.scss';

const propTypes = {
    intl: PropTypes.shape({
        locale: PropTypes.string,
    }).isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    data: PropTypes.shape({
        cardImage: PropTypes.shape({
            url: PropTypes.string,
        }),
        image: PropTypes.shape({
            url: PropTypes.string,
        }),
    }).isRequired,
    thumbnailMedium: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
};

const defaultProps = {
    categories: [],
    className: null,
    thumbnailMedium: null,
};

const ProductionCard = (props) => {
    const {
        intl, className, url, data, title, categories, thumbnailMedium,
    } = props;
    const image = thumbnailMedium || get(data, 'cardImage.url', get(data, 'image.url', null));

    let text = data.summary
        ? data.summary[intl.locale]
        : get(data, `filmInfo.synopsis.${intl.locale}`, null);

    if (isString(text)) {
        const parsed = he.decode(striptags(text));
        text = parsed.length > 150 ? `${parsed.substr(0, 150).trim()}...` : parsed;
    }

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [className]: className !== null,
            })}
        >
            <Link to={url} className={styles.link}>
                {image !== null ? (
                    <span
                        className={styles.image}
                        style={{
                            backgroundImage: `url("${image}")`,
                        }}
                    />
                ) : null}
                <span
                    className={classNames({
                        [styles.mask]: true,
                        [styles.hoverIn]: true,
                    })}
                />
                <span className={styles.label}>
                    <span
                        className={classNames({
                            [styles.inner]: true,
                        })}
                    >
                        <strong className={styles.title}>{title}</strong>
                        {categories !== null && categories.length > 0 ? (
                            <span className={styles.category}>{categories.join(', ')}</span>
                        ) : null}
                        <div
                            className={classNames({
                                [styles.more]: true,
                                [styles.hoverIn]: true,
                            })}
                        >
                            {text !== null ? <p className={styles.text}>{text}</p> : null}
                            <MoreInfo color="cream" link={null} />
                        </div>
                    </span>
                </span>
            </Link>
        </div>
    );
};

ProductionCard.propTypes = propTypes;
ProductionCard.defaultProps = defaultProps;

const mapStateToProps = ({ site }, { data, intl }) => {
    const allCategories = site.productionsCategories || [];
    const categories = get(data, 'categories', [])
        .map(cat =>
            get(allCategories.find(it => it.id === cat) || null, `label.${intl.locale}`, null))
        .filter(it => it !== null);
    return {
        categories,
    };
};
const WithStateContainer = connect(mapStateToProps)(ProductionCard);
const WithIntlContainer = injectIntl(WithStateContainer);
export default WithIntlContainer;



// WEBPACK FOOTER //
// ./js/components/cards/Production.jsx